import React from "react";

import AnimateIconShield from "../icons/animate-icon-shield.jsx";
import AnimateIconClock from "../icons/animate-icon-clock.jsx";
import AnimateIconBacteria from "../icons/animate-icon-microbes.jsx"

import sectionImg from "../images/section-image-nurse.jpg"
import sectionImgMobile from "../images/section-image-nurse-mobile.jpg"
import video2 from "../images/Video-2-screenshot.jpg"

import ResourcesCarousel from './ResourcesCarousel.jsx';
import Form from "./Form.jsx";

function NurseTechnician() {
  return (
    <div>
      <div className="banner nurse img-fluid">
        <div className="container m-padding banner-padding">
          <div className="row">
            <div className="col-md-7 col-sm-6"></div>
          
            <div className="col-md-5 col-sm-6">
              <h2 className="preheader fw-bold color-1 compatil-bold">Information for Nurses and Technicians</h2>
              <h1 className="display-3 fw-bold color-1 compatil-bold mb-3"><span className="no-break">The Benefits of</span> <span className="color-2">Chlorhexidine</span></h1>
              <h3 className="fw-bold color-1 compatil-bold desktop">Chlorhexidine is a broad&#8209;spectrum disinfectant and antiseptic that significantly reduces the occurrence of CLABSI&#8209;causing pathogens.<sup>1</sup></h3>
            </div>
          </div>
        </div>
      </div>

      <div className="container mobile">
        <div className="row pt-5 pb-5">
          <div className="col-md-6 col-sm-6">
            <h2 className="fw-bold color-1 compatil-bold text-center">Chlorhexidine is a broad&#8209;spectrum disinfectant and antiseptic that significantly reduces the occurrence of CLABSI&#8209;causing pathogens.<sup>1</sup></h2>
          </div>
        </div>
      </div>

      <div className="container max">
        <div className="row grey-hov">
          <div className="icon-hover xl flex-v col-md-4 col-sm-6 text-center py-5">
            <div className="hover-container">
              <div className="state-1">
                <AnimateIconShield />
              </div>
              <div className="desktop">
                <h3 className="color-2 open-sans pt-3 state-1"><strong>Available in Max<br></br> Barrier Kits</strong></h3>
                <h3 className="color-1 open-sans state-2">Arrowg+ard Blue Advance<sup>&trade;</sup><br></br> PICCs and Midline kits have<br></br> <strong>the components you need<br></br> for bedside insertion</strong>,<br></br> designed to help <strong>save you<br></br> valuable prep time.</strong></h3>
              </div>
              <div className="mobile">
                <h3 className="color-2 open-sans min pt-3 state-1"><strong>Available in Max<br></br> Barrier Kits</strong></h3>
                <h3 className="color-1 open-sans min no-margin state-2">Arrowg+ard Blue Advance<sup>&trade;</sup> PICCs and<br></br> Midline kits have <strong>the components you<br></br> need for bedside insertion</strong>, designed to help <strong>save you valuable prep time.</strong></h3>
              </div>
            </div>
          </div>
          <div className="icon-hover xl flex-v col-md-4 col-sm-6 text-center py-5">
            <div className="hover-container">
              <div className="state-1">
                <AnimateIconBacteria />
              </div>
              <div className="desktop">
                <h3 className="color-2 open-sans pt-3 state-1"><strong>Protecting Areas<br></br> Clinically Out of Reach<sup>1,2</sup></strong></h3>
                <h3 className="color-1 open-sans state-2">Arrowg+ard Blue <br></br>Advance<sup>&trade;</sup> Catheters with<br></br> chlorhexidine are proven to<br></br><strong>reduce CLABSI-causing<br></br>pathogens by 99.99%</strong><br></br>for at least 30 days.<sup>3</sup></h3>
              </div>
              <div className="mobile">
                <h3 className="color-2 open-sans min pt-3 state-1"><strong>Protecting Areas<br></br> Clinically Out of Reach<sup>1,2</sup></strong></h3>
                <h3 className="color-1 open-sans min state-2">Arrowg+ard Blue <br></br>Advance<sup>&trade;</sup> Catheters with chlorhexidine<br></br> are proven to <strong>reduce CLABSI-causing<br></br>pathogens by 99.99%</strong><br></br>for at least 30 days.<sup>3</sup></h3>
              </div>
            </div>
          </div>
          <div className="icon-hover xl flex-v col-md-4 col-sm-6 text-center py-5">
            <div className="hover-container">
              <div className="state-1">
                <AnimateIconClock />
              </div>
              <div className="desktop">
                <h3 className="color-2 open-sans pt-3 state-1"><strong>Antithrombogenic<br></br> Properties<sup>2</sup></strong></h3>
                <h3 className="color-1 open-sans state-2">Chlorhexidine in<br></br> Arrowg+ard Blue Advance<sup>&trade;</sup><br></br>Catheters also works<br></br>continuously to <strong>prevent<br></br> catheter buildup</strong> of<br></br>fibrin shealth, <strong>reducing<br></br>the risk of intraluminal<br></br>thrombotic occlusion<sup>2</sup></strong></h3>
              </div>
              <div className="mobile">
                <h3 className="color-2 open-sans min pt-3 state-1"><strong>Antithrombogenic<br></br> Properties<sup>2</sup></strong></h3>
                <h3 className="color-1 open-sans min state-2">Chlorhexidine in Arrowg+ard Blue<br></br> Advance<sup>&trade;</sup> Catheters also works<br></br>continuously to <strong>prevent catheter<br></br> buildup</strong> of fibrin shealth, <strong>reducing<br></br>the risk of intraluminal thrombotic<br></br> occlusion<sup>2</sup></strong></h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="banner-section section-bg-2 img-fluid flex-v">
        <div className="container m-padding pad-m-y">
          <div className="row flex-v--">
            <div className="col-md-4 col-sm-6">
              <h2 className="fw-bold compatil-bold text-white mb-5 mb">When you think Antimicrobial Protection, think BLUE</h2>
              <h2 className="xl-text open-sans color-1"><strong>99.99%</strong></h2>
              <h3 className="open-sans min color-1"><strong>Colonization Reduction</strong></h3>
              <h4 className="open-sans min text-white mb-5 mb">in gram&#8209;positive and gram&#8209;negative bacterial and fungal pathogens for at least 30 days.<sup>3</sup></h4>
            </div>
          </div>
        </div>
      </div>
      <p className="open-sans text-center fst-italic mt-2">Products may not be available in all countries. Please contact your local representative.</p>

      <div className="container py-5">
        <div className="row pad-m-y">
          <h2 className="fw-bold compatil-bold color-1 text-center align-left-m mb-5 mb m-padding">See the Difference Arrowg+ard Blue Advance<sup>&trade;</sup> Protection Makes<sup>4,5</sup></h2>
          <div className="video-container">
            <iframe
              src='https://teleflex.widen.net/view/video/aobtee5tub/Video_AGBA-Biofilm.mp4?u=nrie10'
              frameborder='0'
              allow='autoplay; encrypted-media'
              allowfullscreen
              title='video'
            />
          </div>
        </div>
      </div>

      <div className="container max desktop">
        <div className="row">
          <div className="bg-grey split-width flex-v">
            <div className="split-text-col col-md-7 offset-md-3 pb-5">
              <h2 className="open-sans color-2 pb-2"><strong>Your Vascular<br></br> Access Partner</strong></h2>
              <h4 className="open-sans md color-1 pb-2">At Teleflex, we share your<br></br> commitment to patient safety.</h4>
              <ul className="open-sans color-1 mb-5">
                <h5><li>We’re your partner in vascular access, working to provide the most up-to-date information on 
                  <a className="blue-link" href="./#hob"> <u>changing guidelines</u> </a>
                  to ensure your teams are prepared</li></h5>
                <h5><li>We work with you to provide hands-on training, bedside coaching, and metrics for success</li></h5>
              </ul>
              <a href="./information" target="_blank" className="btn btn-primary btn-md" type="button">Chlorhexide Sensitivity Information</a>
            </div>
          </div>
          <div className="col-md-6 col-sm-6">
            <img src={sectionImg} alt="" className="img-fluid" />
          </div>
        </div>
      </div>

      <div className="container max mobile">
        <div className="row bg-grey">
          <div className="col-md-6">
            <img src={sectionImgMobile} alt="" className="img-fluid" />
          </div>
          <div className="col-md-6 pb-5 pad-m-y">
            <h2 className="open-sans color-2 pb-2 m-padding"><strong>Your Vascular<br></br> Access Partner</strong></h2>
            <h4 className="open-sans min md color-1 pb-2 m-padding">At Teleflex, we share your<br></br> commitment to patient safety.</h4>
            <ul className="open-sans color-1 mb-5">
              <h5 className="open-sans m-padding">
                <li>We’re your partner in vascular access, working to provide the most up-to-date information on 
                  <a className="blue-link" href="./#hob"> <u>changing guidelines</u> </a>
                   to ensure your teams are prepared</li>
              </h5>
              <h5 className="open-sans m-padding"><li>We work with you to provide hands-on training, bedside coaching, and metrics for success</li></h5>
            </ul>
            <div className="text-center">
              <a href="./information" target="_blank" className="btn btn-primary btn-md" type="button">Chlorhexide Sensitivity Information</a>
            </div>
          </div>
        </div>
      </div>

      <ResourcesCarousel />
      <Form formId={1264} />
      {/* references */}
      <div className="references container pb-5">
        <div className="row pt-5 ref-text open-sans color-3">
          <p>References:
            <ol>
              <li>Ryder MA, et al. Reduction of Extraluminal Bacterial Colonization Using Chlorhexidine Antimicrobial-coated PICC Catheters in a Clinically Simulated Ovine Model. Infusion Nurses Society Annual Convention and Industrial Exhibition; 2012.</li>
              <li>Ryder MA, et al. The Effect of Chlorhexidine Catheter Coating Compared to an Uncoated and Biomimetic Catheter on the Reduction of Fibrin Sheath Formation in an in vivo Clinically Simulated Ovine Model. Infusion Nurses Society Annual Convention and Industrial Exhibition; 2012.</li>
              <li>In vitro data on file 2010: AVER-004371 and AVER-004483. No correlation between in vitro/in vivo testing methods and clinical outcomes has currently been ascertained.</li>
              <li>Mermel LA. What is the evidence for intraluminal colonization of hemodialysis catheters?. <i>Kidney Int</i>. 2014;86(1):28-33. doi:10.1038/ki.2013.527</li>
              <li>O’Grady NP, Alexander M, Burns LA, et al; Healthcare Infection Control Practices Advisory Committee (HICPAC). Guidelines for the prevention of intravascular catheter-related infections, 2011. CDC. Updated October 2017. Accessed January 29, 2024. <a href="https://www.cdc.gov/infectioncontrol/pdf/guidelines/bsi-guidelines-H.pdf" target="_blank" rel="noopener noreferrer">https://www.cdc.gov/infectioncontrol/pdf/guidelines/bsi-guidelines-H.pdf</a></li>
            </ol>
          </p>
          <p className="pb-4">Rx Only</p>
          <p>Contraindications:</p>
          <p>Clinical assessment of the patient must be completed to ensure no contraindications exist. Arrowg+ard Blue Advance™ Catheters are contraindicated in the following areas:</p>
          <p>
            <ul className="no-margin pb-1">
              <li>Patients with known hypersensitivity to chlorhexidine</li>
              <li>In presence of device-related infections</li>
              <li>In presence of previous or current thrombosis in the intended vessel or along the catheterized vessel pathway</li>
            </ul>
          </p>
          <p className="pb-4">No correlation between <i>in vitro/in vivo</i> testing methods and clinical outcomes have currently been ascertained.</p>
          <p className="sm">Teleflex, the Teleflex logo, Arrow and Arrowg+ard Blue Advance are trademarks of Teleflex Incorporated or its affiliates, in the U.S. and/or other countries. All other trademarks are trademarks of their respective owners. MC-008512</p>
        </div>
      </div>

    </div>
  );
}

export default NurseTechnician;
